export function setBicis(state, bicis) {
    state.bicis = bicis;
}

export function setBiciSelec(state, bici) {
    state.biciSelec = bici;
}

export function actListBicis(state, bici) {
    if (bici !== null) {
        const index = state.bicis.findIndex(r => r.id === bici.id)
        if (index != -1) {
            state.bicis[index].numero = bici.numero;  
            state.bicis[index].talla = bici.talla;  
            state.bicis[index].marca = bici.marca;  
            state.bicis[index].observaciones = bici.observaciones;  
        }
    }
  
}

export function actDeleteListBicis(state, id) {
    if (id != null) {
        const index = state.bicis.findIndex(r => r.id === id)
        if (index != -1) {
            state.bicis.splice(index, 1)
        }
    }
}